import axios from "../axios";

export const CheckUserRole = async (email) => {
  return await axios.post("api/Auth/CheckUserRole", { email })
};

export const SendClientOtp = async (email) => {
  return await axios.post("api/auth/client/send-otp", { email });
};

export const ClientLogin = async (email, otp) => {
  const response = await axios.post("api/auth/client/login", {
    email,
    otp,
  });

  return response.data;
};

export const OrbitLogin = async (email, password, keepMeLoggedIn = false) => {
  const payload = {
    email,
    password,
    keepMeLoggedIn,
  };
  try {
    const response = await axios.post("api/Auth/Login", payload, {
      headers: {
        "X-Public-Request": true,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get UserName and email after login
//Harshada Bhavsar - (20/11/2025)
export const GetCurrentUser = async () => {
  try {
    const response = await axios.get("api/Auth/me");
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Failed to fetch user");
    } else {
      throw new Error("Network error or server unreachable");
    }
  }
};

export const Logout = async () => {
  return axios.post("/api/Auth/Logout");
};

export const ForceLogout = async (email, slot) => {
  return axios.post("/api/Auth/ForceLogout", { email, slot });
};
